
import { linkListStyles } from "@insite/content-library/Widgets/Basic/SocialLinks";
import { css } from "styled-components";

linkListStyles.linkWrapper = {
	css: css`
       .social-link{
	   		padding: 0 5px;
			span[class^="IconWrapper"]{
				width: 40px;
				height:40px;
				svg{
					width: 40px;
					height:40px;
				}
			}
	   }
    `,
};